angular.module('impactx.sidebar').component('ixMenuSidebarToggle', {
        controller: 'MenuSidebarToggleCtrl',
        templateUrl: 'shared/sidebar/templates/menu-sidebar-toggle.html'
    }
);